<div class="usan-form-item pegylated-nucleic-acid-based-substances-container">
    <div class="usan-checklist-item">
        <div class="usan-checklist-icon-column">
        <mat-icon>{{ wasFileUploaded ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
        </div>
        <div class="usan-checklist-content-column flex-wrap">
          <span class="usan-form-item pegylated-nucleic-acid-based-substances-item pegylated-nucleic-acid-based-substances-text" [innerHTML]="title">
          </span>
          <div class="break"></div>
          <div class="usan-form-item pegylated-nucleic-acid-based-substances-item pegylated-nucleic-acid-based-substances-text" [innerHTML]="infoText">
          </div>
        </div>
    </div>
    <div class="usan-form-item button-layout layout-centered">
        <button type="button" class="upload-pegylated-nucleic-acid-based-substances form-btn form-btn-style form-btn-text"
        (click)="openDialog()">
            <mat-icon class="form-btn-icon">upload</mat-icon>
            {{ buttonText }}
        </button>
    </div>
    <ng-container *ngIf="wasFileUploaded">
        <div class="full-width" *ngFor="let file of attachments">
        <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
        </div>
    </ng-container>
</div>